export default "__VITE_ASSET__e01d7349__"